export default __webpack_public_path__ + "static/media/closet5-after2-768w.8d185360.webp";